<template>
	<div :class="`video-block video-block--${block.content.alignment}`">
		<client-only-wrapper>
			<vue-plyr>
				<div>
					<iframe :src="currentVideoUrl(block.content.media.url)" />
				</div>
			</vue-plyr>

			<caption
				v-if="block.content.caption"
				class="video-block__caption"
			>
				<a
					v-if="block.content.caption_link"
					target="_blank"
					:href="block.content.caption_link"
				>
					{{ block.content.caption }}
				</a>
				<template v-else>
					{{ block.content.caption }}
				</template>
			</caption>
		</client-only-wrapper>
	</div>
</template>

<script>
import ClientOnlyWrapper from '../../../client-only-wrapper/ClientOnlyWrapper.vue';

export default {
	components: {
		ClientOnlyWrapper,
	},

	props: {
		block: {
			type: Object,
			required: true,
		},

		next: {
			type: Object,
			required: false,
			default: null,
		},
	},

	methods: {
		currentVideoUrl(url) {
			if (url.lastIndexOf('youtube.com') > -1) {
				const params = '?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1';
				return `${url}${params}`;
			}

			if (url.lastIndexOf('vimeo.com') > -1) {
				const params = '?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media';
				const id = url.replace('https://vimeo.com/', '');
				return `https://player.vimeo.com/video/${id}${params}`;
			}

			return null;
		},
	},
};
</script>

<style lang="scss" src="./video-block.scss" />
